export const DashboardRbhExcelHeader = [
  {
    header: "REF NO",
    key: "REF NO",
    width: 25,
  },
  {
    header: "CUSTOMER PO",
    key: "CUSTOMER PO",
  },
  {
    header: "REQUESTED DELIVERY DATE",
    key: "REQUESTED DELIVERY DATE",
  },

  {
    header: "CUSTOMER CODE",
    key: "CUSTOMER CODE",
  },
  {
    header: "CATEGORY",
    key: "CATEGORY",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "CORE UNIT CARRIER",
    key: "CORE UNIT CARRIER",
  },
  {
    header: "CORE UNIT SN",
    key: "CORE UNIT SN",
  },
  {
    header: "CORE UNIT NOTIFIED DATE",
    key: "CORE UNIT NOTIFIED DATE",
  },
  {
    header: "CORE UNIT AWB",
    key: "CORE UNIT AWB",
  },
  {
    header: "SERVICEABLE NOTIFIED DATE",
    key: "SERVICEABLE NOTIFIED DATE",
  },
  {
    header: "SERVICEABLE AWB",
    key: "SERVICEABLE AWB",
  },
  {
    header: "SERVICEABLE SN",
    key: "SERVICEABLE SN",
  },
  {
    header: "SERVICEABLE",
    key: "SERVICEABLE",
  },
  {
    header: "CORE UNIT",
    key: "CORE UNIT",
  },
  {
    header: "IS POOL",
    key: "IS POOL",
  },
  {
    header: "AIRPORT CODE",
    key: "AIRPORT CODE",
  },
  {
    header: "AIRCRAFT",
    key: "AIRCRAFT",
  },
  {
    header: "REQUEST DATE",
    key: "REQUEST DATE",
  },
  {
    header: "STATUS",
    key: "STATUS",
  },
  {
    header: "PBH NOTES",
    key: "PBH NOTES",
    isCustomer: false,
  },
  {
    header: "CORE UNIT REMOVAL DATE",
    key: "CORE UNIT REMOVAL DATE",
  },
  {
    header: "REMOVE REASON",
    key: "REMOVE REASON",
  },
  {
    header: "CORE UNIT REMARK",
    key: "CORE UNIT REMARK",
  },
  {
    header: "SHIPMENT ARRIVED",
    key: "SHIPMENT ARRIVED",
  },
  {
    header: "ORDINO DATE",
    key: "ORDINO DATE",
  },
  {
    header: "REPLACEMENT PENDING DATE",
    key: "REPLACEMENT PENDING DATE",
  },
  {
    header: "REMAINING RDD",
    key: "REMAINING RDD",
  },
  {
    header: "WH COUNT",
    key: "WH COUNT",
    isCustomer: false,
  },
  {
    header: "CORE UNIT REMOVE REASON REMARK",
    key: "CORE UNIT REMOVE REASON REMARK",
  },
  {
    header: "BATCH",
    key: "BATCH",
  },
  {
    header: "XO NUMBER",
    key: "XO NUMBER",
    isCustomer: false,
  },
  {
    header: "TT-WO",
    key: "TTWo",
    isCustomer: false,
  },
  {
    header: "TT-RO",
    key: "TTRo",
    isCustomer: false,
  },
  {
    header: "Location",
    key: "Location",
    isCustomer: false,
  },
  {
    header: "RO Status",
    key: "RoStatus",
    isCustomer: false,
  },
  {
    header: "FLIGHT DATE",
    key: "FlightDate",
  },
  {
    header: "FLIGHT NO",
    key: "FlightNo",
  },
  {
    header: "Experience Remark",
    key: "ExperienceRemark",
    isCustomer: true,
  },
];
export const DashboardRbhExcelName = "Request Dashboard RBH List";
